import { LogoTransparent } from "../../assets";
import { HoveredButton } from "../ui/Buttons/Hovered";


export function FooterMaximized(){
    return (
        <footer className="bg-[#1D1D39]  pb-4 pt-14 xl:px-0 px-8">
            <div className="flex flex-col xl:flex-row xl:justify-between border-b  border-[#BBBBC4] pb-8 xl:w-3/4 xl:mx-auto">
                <div className="xl:w-[14rem] space-y-3 xl:my-5">
                    <img src={LogoTransparent} alt="wos logo" />
                    <div className="text-[#BBBBC4]  text-start text-[16px] xl:text-[14px] xl:w-10/12">
                        Connectez-vous à notre plateforme et découvrez des talents internationaux à un coût mensuel avantageux.
                    </div>
                </div>

                <div className="flex-1 lg:flex my-6">
                    <div className="mt-.5 flex-1 xl:flex justify-end xl:my-0 my-4 lg:my-0 text-[16px] xl:text-[14px]">
                        <div className="space-y-3">
                            <div className="text-[#BBBBC4] text-start">Je veux recruter</div>
                            <ul className="m-0 p-0 text-white ">
                                <li>Comment ça marche ?</li>
                                <li>Nos freelances</li>
                                <li>Inscription entreprise</li>
                            </ul>
                        </div>
                    </div>

                    <div className="mt-.5 flex-1 xl:flex justify-end xl:my-0 my-4 lg:my-0 text-[16px] xl:text-[14px]">
                        <div className="space-y-3">
                            <div className="text-[#BBBBC4] text-start">Je veux travailler</div>
                            <ul className="m-0 p-0 text-white">
                                <li>Comment ça marche ?</li>
                                <li>Les services</li>
                                <li>Inscription freelance</li>
                            </ul>
                        </div>
                    </div>

                    <div className="mt-.5 flex-1 xl:flex justify-end xl:my-0 my-4 lg:my-0 text-[16px] xl:text-[14px]">
                        <div className="space-y-3">
                            <div className="text-[#BBBBC4] text-start">Wall of Share</div>
                            <ul className="m-0 p-0 text-white">
                                <li>À propos</li>
                                <li>Contactez-nous</li>
                            </ul>
                        </div>
                    </div>

                    <div className="mt-.5 flex-1 xl:flex justify-end text-[16px] xl:text-[14px]">
                        <div className="xl:space-y-3 space-y-4 lg:space-y-0 lg:space-x-20">
                            <button className="bg-gradient-to-r outline-none from-purple-500 via-pink-500 to-orange-500 text-white  px-6 rounded-md shadow-sm py-1 block    lg:ml-20">S'inscrire</button>
                            <HoveredButton text='Se connecter' rounded='rounded-md' className='bg-primary-blue '/>
                        </div>
                    </div>
                </div>

            </div>
            <div className="text-[#BBBBC4] text-center mt-4 mb-12 text-[16px] xl:text-[14px]">2024 © Wall Of Share Tous droits réservés</div>
        </footer>
    )
}

export default function Footer(){
    return (
        <footer className="bg-[#1D1D39]  pb-4 pt-14 xl:px-0 px-8">
            <div className="text-[#BBBBC4] text-center mt-4 mb-12 text-[16px] xl:text-[14px]">2024 © Wall Of Share Tous droits réservés</div>
        </footer>
    )
}